var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sticky-menu", class: { mobile: _vm.isMobile } },
    [
      _c(
        "nav",
        { staticClass: "grid", class: { light: _vm.image == "light" } },
        [_vm._m(0)]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "unit two-thirds" }, [
      _c("a", { attrs: { href: "/" } }, [
        _c("img", {
          staticClass: "logo before",
          attrs: { src: require("@/assets/img/logo-nav-new.png") }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "logo after",
          attrs: { src: require("@/assets/img/logo-nav-new.png") }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33dac617", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33dac617","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./apps/comps/header.vue
// module id = 552
// module chunks = 0